// removed by extract-text-webpack-plugin
module.exports = {"container":"_3UeZOpT1NPylWf_ZSk2lf0"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Page/styles.css
// module id = 3146
// module chunks = 0